// Copyright (c) 2018 Robert Rypuła - https://github.com/robertrypula

export const version = '1.2.0';
export const author = 'Robert Rypuła';
export const githubUrl = 'https://github.com/robertrypula';
